import revive_payload_client_4sVQNw7RlN from "/Users/bridgecode/workspace/insabank/insabank_frontend/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/Users/bridgecode/workspace/insabank/insabank_frontend/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Users/bridgecode/workspace/insabank/insabank_frontend/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/Users/bridgecode/workspace/insabank/insabank_frontend/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/Users/bridgecode/workspace/insabank/insabank_frontend/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/Users/bridgecode/workspace/insabank/insabank_frontend/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/Users/bridgecode/workspace/insabank/insabank_frontend/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/Users/bridgecode/workspace/insabank/insabank_frontend/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/Users/bridgecode/workspace/insabank/insabank_frontend/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/Users/bridgecode/workspace/insabank/insabank_frontend/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_cmDI8mptrG from "/Users/bridgecode/workspace/insabank/insabank_frontend/node_modules/nuxt3-lenis/dist/runtime/plugin.mjs";
import restoreToken_gtEvn7J1fE from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/plugins/restoreToken.js";
import swiper_O3lneWMUiB from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/plugins/swiper.js";
import multiselect_4FGQx32SYh from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/plugins/multiselect.js";
import fetchApi_bP37pqyxCu from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/plugins/fetchApi.js";
import ga_client_94BfwC9GtA from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/plugins/ga.client.js";
import naver_wcs_client_yEzHYji6M9 from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/plugins/naver-wcs.client.js";
import quill_client_3HMwhWEPwq from "/Users/bridgecode/workspace/insabank/insabank_frontend/src/plugins/quill.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_cmDI8mptrG,
  restoreToken_gtEvn7J1fE,
  swiper_O3lneWMUiB,
  multiselect_4FGQx32SYh,
  fetchApi_bP37pqyxCu,
  ga_client_94BfwC9GtA,
  naver_wcs_client_yEzHYji6M9,
  quill_client_3HMwhWEPwq
]